module.exports = __webpack_public_path__ + "static/media/portfolio-3.47f0b2f9.jpg";